module.exports = __webpack_public_path__ + "static/media/YB5F02_2.a3cd4586.jpg";